var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3333 14C27.3333 21.364 21.364 27.3334 14 27.3334C6.63596 27.3334 0.666626 21.364 0.666626 14C0.666626 6.63602 6.63596 0.666687 14 0.666687C21.364 0.666687 27.3333 6.63602 27.3333 14ZM9.95996 9.96002C10.1475 9.77275 10.4016 9.66757 10.6666 9.66757C10.9316 9.66757 11.1858 9.77275 11.3733 9.96002L14 12.5867L16.6266 9.96002C16.8162 9.78338 17.0669 9.68721 17.326 9.69179C17.5851 9.69636 17.8322 9.80131 18.0155 9.98452C18.1987 10.1677 18.3036 10.4149 18.3082 10.674C18.3128 10.9331 18.2166 11.1838 18.04 11.3734L15.4133 14L18.04 16.6267C18.2166 16.8163 18.3128 17.067 18.3082 17.326C18.3036 17.5851 18.1987 17.8323 18.0155 18.0155C17.8322 18.1987 17.5851 18.3037 17.326 18.3083C17.0669 18.3128 16.8162 18.2167 16.6266 18.04L14 15.4134L11.3733 18.04C11.1837 18.2167 10.933 18.3128 10.6739 18.3083C10.4149 18.3037 10.1677 18.1987 9.98446 18.0155C9.80125 17.8323 9.6963 17.5851 9.69172 17.326C9.68715 17.067 9.78332 16.8163 9.95996 16.6267L12.5866 14L9.95996 11.3734C9.77269 11.1859 9.66751 10.9317 9.66751 10.6667C9.66751 10.4017 9.77269 10.1475 9.95996 9.96002Z",
    fill: "#A69F98",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e8d75a51b9f0f469cd7d9587d9516da2.svg";
export { ForwardRef as ReactComponent };